/** Shopify CDN: Minification failed

Line 46:1 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 47:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 47:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 48:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 48:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 54:47 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 59:8 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 65:8 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 65:22 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 67:12 Transforming const to the configured target environment ("es5") is not supported yet
... and 1 more hidden warnings

**/
/** Shopify CDN: Minification failed

Line 31:1 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 32:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 32:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 33:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 33:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 39:47 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 44:8 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 50:8 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 50:22 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 52:12 Transforming const to the configured target environment ("es5") is not supported yet
... and 1 more hidden warnings

**/
/** Shopify CDN: Minification failed

Line 16:1 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 17:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 17:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 18:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 18:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 24:47 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 29:8 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 35:8 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 35:22 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 37:12 Transforming const to the configured target environment ("es5") is not supported yet
... and 1 more hidden warnings

**/
(async () => {
    const { Core } = await importModule('Core');
    const { 
        parseHTML,
        $clone,
    } = await importModule('Utils');


    customElements.define('cart-notification', class extends Core {
        subscriptions = {
            'cart:update': '_update'
        }

        async render() {
            await customElements.whenDefined('cart-provider');
            this.publish('cart:add-feature', { feature: 'notification' });
            this.subscribe('cart:update', { global: true });            
        }

        async _update({ notification }) {
            if (!notification?.section) return;
            const $doc = parseHTML(notification.section);
            this.$container = $clone($doc.querySelector('[data-content]'));
            this._openModal();
        }

        _openModal() {
            this.publish('modal:open', {
                content: this.$container,
                position: 'top-center',
                animation: 'slideTop'
            })
        }
    })
})();